import React from "react";
import { Card, Menu, Space } from "antd";
import { Link, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Megamenu = () => {
  const navigation = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };

  const [open, setOpen] = useState(false);
  const handleMenuClick = (e) => {
    if (e.key === "3") {
      setOpen(false);
    }
  };

  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className=" bg-white">
      <div className="">
        <div className=" ">{/* <SubHeader /> */}</div>
        <div
          style={{ color: "" }}
          className="   min-w-full  justify-center items-center  flex   "
        >
          {/* <Menu
          mode="horizontal"
          className=" w-28  border-0    "
         
         
          items={[
            {
              label: "INTERIORS",
              key: "hi",
              className:" w-28 text-black  ",
            
              children: [
                {
                  label: <Bigmenu />,
                  key: "gu2",
                  className:` text-black`,
                  style: {
                    height: "fit-content",
                width:"100%",
                    padding:0,
                    
                  
                  },
                
                },
                
              ],
            },
          ]}
        />
         <Menu
          mode="horizontal"
          className="  w-28 border-2"
          items={[
            {
              label: "EXTERIORS",
              key: "hi",
              className:"text-black   ",
              children: [
                {
                  label: <Bigmenu2 />,

                  key: "gu",
                 
                  style: {
                    height: "fit-content",
                width:"100%",
                    padding:0,
                    
                  
                  },
                },
              ],
            },
          ]}
        /> */}

          {/* <Menu mode="vertical"   className="min-w-fit  border-0">
          {dummyMenuData?.map((category) => (
            <Menu.SubMenu  key={category.key} title={category.label}>
              {category.children?.map((item) => (
                <Menu.Item key={item.key}>
                  {item.children ? (
                    <Menu.SubMenu title={item.label}>
                      {item.children?.map((subItem) => (
                        <Menu.Item key={subItem.key}>{subItem.label}</Menu.Item>
                      ))}
                    </Menu.SubMenu>
                  ) : (
                    <span
                      onClick={() =>
                        navigation(
                          `category/${item.label.replace(/\s+/g, "-")}`
                        )
                      }
                    >
                      {" "}
                      {item.label}
                    </span>
                  )}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          ))}
        </Menu> */}
          <Menu
            mode="horizontal"
            className="  border-2"
            items={[
              {
                label: "CAR ACCESSORIES",
                key: "hi",
                className: "text-black  min-w-fit  ",
                children: [
                  {
                    label: "Interiors",

                    key: "gu",

                    style: {
                      height: "fit-content",
                      width: "100%",
                      padding: "0px 0px",
                    },
                    children: [
                      {
                        label: <Bigmenu />,
                        key: "gu4",
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",

                          padding: "0px 0px",
                        },
                      },
                    ],
                  },
                  {
                    label: "Exteriors",

                    key: "guuuu",

                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: <Bigmenu2 />,
                        key: "gu41s",
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Lighthing",

                    key: "lighting",

                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Halogen Bulb",
                        key: "halogen-bulb",
                        onClick: () => navigation("/category/halogen-bulb"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Led Light",
                        key: "led-lights",
                        onClick: () => navigation("/category/led-light"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "HID Light",
                        key: "hid-light",
                        onClick: () => navigation("/category/hid-light"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Reflector Light",
                        key: "reflector-light",
                        onClick: () => navigation("/category/reflector-light"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Pillar light",
                        key: "pillar-light",
                        onClick: () => navigation("/category/pillar-light"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Bar light",
                        key: "bar-light",
                        onClick: () => navigation("/category/bar-light"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "DRL light",
                        key: "drl-light",
                        onClick: () => navigation("/category/drl-light"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Decorative light",
                        key: "decorative-light",
                        onClick: () => navigation("/category/decorative-light"),
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Filters",
                    key: "filterrrrrrs",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Cabin A/C Filters",
                        key: "cabin-ac-filters",
                        onClick: () => navigation("/category/cabin-ac-filters"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Engine Air Filters",
                        key: "engine-air-filters",
                        onClick: () =>
                          navigation("/category/engine-air-filters"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Engine Oil Filters",
                        key: "engine-oil-filters",
                        onClick: () =>
                          navigation("/category/engine-oil-filters"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Fuel Filters",
                        key: "fuel-filters",
                        onClick: () => navigation("/category/fuel-filters"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Essentials",
                    key: "essentials",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Steering Wheel Tray",
                        key: "steering-wheel-tray",
                        onClick: () =>
                          navigation("/category/steering-wheel-tray"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Should Pad",
                        key: "should-pad",
                        onClick: () => navigation("/category/should-pad"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Mobile Chargers",
                        key: "mobile-chargers",
                        onClick: () => navigation("/category/mobile-chargers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Non Slip Mats & Trays",
                        key: "non-slip-mats-and-trays",
                        onClick: () =>
                          navigation("/category/non-slip-mats-and-trays"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Ashtray",
                        key: "ashtray",
                        onClick: () => navigation("/category/ashtray"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Door Buffer",
                        key: "door-buffer",
                        onClick: () => navigation("/category/door-buffer"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Safety & Breakdown Assistance",
                    key: "safety-breakdown-assistance",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Emergency Tool Kits",
                        key: "emergency-tool-kits",
                        onClick: () =>
                          navigation("/category/emergency-tool-kits"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Jumper Cable",
                        key: "jumper-cable",
                        onClick: () => navigation("/category/jumper-cable"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Towing Ropes",
                        key: "towing-ropes",
                        onClick: () => navigation("/category/towing-ropes"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Tyre Inflators",
                        key: "tyre-inflators",
                        onClick: () => navigation("/category/tyre-inflators"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Tow Hooks",
                        key: "tow-hooks",
                        onClick: () => navigation("/category/tow-hooks"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Tyre Puncture Kits",
                        key: "tyre-puncture-kits",
                        onClick: () =>
                          navigation("/category/tyre-puncture-kits"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Central Locking",
                        key: "central-locking",
                        onClick: () => navigation("/category/central-locking"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Tyre Lock",
                        key: "tyre-lock",
                        onClick: () => navigation("/category/tyre-lock"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Steering Wheel Lock",
                        key: "steering-wheel-lock",
                        onClick: () =>
                          navigation("/category/steering-wheel-lock"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },

                  {
                    label: "Car Styling and Body Fittings",
                    key: "car-styling-and-body-fittings",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Aerials/Anteena",
                        key: "aerials-anteena",
                        onClick: () => navigation("/category/aerials-anteena"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Wing Mirror Assembly",
                        key: "wing-mirror-assembly",
                        onClick: () =>
                          navigation("/category/wing-mirror-assembly"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Roof Rails",
                        key: "roof-rails",
                        onClick: () => navigation("/category/roof-rails"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Front Grills",
                        key: "front-grills",
                        onClick: () => navigation("/category/front-grills"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Bumper Clips",
                        key: "bumper-clips",
                        onClick: () => navigation("/category/bumper-clips"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Wing Mirror Outer Cover",
                        key: "wing-mirror-outer-cover",
                        onClick: () =>
                          navigation("/category/wing-mirror-outer-cover"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Side Beading",
                        key: "side-beading",
                        onClick: () => navigation("/category/side-beading"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Wiper",
                        key: "wiper",
                        onClick: () => navigation("/category/wiper"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },

                  {
                    label: "Air Freshener",
                    key: "air-freshener",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Gel Freshener",
                        key: "gel-freshener",
                        onClick: () => navigation("/category/gel-freshener"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Solar Perfume",
                        key: "solar-perfume",
                        onClick: () => navigation("/category/solar-perfume"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Spray",
                        key: "spray",
                        onClick: () => navigation("/category/spray"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Wheel Covers",
                    key: "wheel-covers",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "12 Inch",
                        key: "12-inch",
                        onClick: () =>
                          navigation("/category/12-inch-wheel-covers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "13 Inch",
                        key: "13-inch",
                        onClick: () =>
                          navigation("/category/13-inch-wheel-covers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "14 Inch",
                        key: "14-inch",
                        onClick: () =>
                          navigation("/category/14-inch-wheel-covers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "15 Inch",
                        key: "15-inch",
                        onClick: () =>
                          navigation("/category/15-inch-wheel-covers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "16 Inch",
                        key: "16-inch",
                        onClick: () =>
                          navigation("/category/16-inch-wheel-covers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Gas Springs",
                    key: "gas-springs",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Bonnet Gas Spring",
                        key: "bonnet-gas-spring",
                        onClick: () =>
                          navigation("/category/bonnet-gas-spring"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Boot Gas Spring",
                        key: "boot-gas-spring",
                        onClick: () => navigation("/category/boot-gas-spring"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },

                  {
                    label: "Wrap Decals & Stickers",
                    key: "wrap-decals-stickers",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Car Vents",
                        key: "car-vents",
                        onClick: () => navigation("/category/car-vents"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Wing Mirror Stickers",
                        key: "wing-mirror-stickers",
                        onClick: () =>
                          navigation("/category/wing-mirror-stickers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Side Fender Stickers",
                        key: "side-fender-stickers",
                        onClick: () =>
                          navigation("/category/side-fender-stickers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Bumper Stickers",
                        key: "bumper-stickers",
                        onClick: () => navigation("/category/bumper-stickers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Dicky Stickers",
                        key: "dicky-stickers",
                        onClick: () => navigation("/category/dicky-stickers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Rim Stickers",
                        key: "rim-stickers",
                        onClick: () => navigation("/category/rim-stickers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Car Care & Utility",
                    key: "car-care-utility",
                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: "Cleaning",
                        key: "cleaning",
                        onClick: () => navigation("/category/cleaning"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Vacuum Cleaners",
                        key: "vacuum-cleaners",
                        onClick: () => navigation("/category/vacuum-cleaners"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Air Compressors",
                        key: "air-compressors",
                        onClick: () => navigation("/category/air-compressors"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Duster & Microfibers",
                        key: "duster-microfibers",
                        onClick: () =>
                          navigation("/category/duster-microfibers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Scratch Removers",
                        key: "scratch-removers",
                        onClick: () => navigation("/category/scratch-removers"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Spray Paints",
                        key: "spray-paints",
                        onClick: () => navigation("/category/spray-paints"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Lubricants",
                        key: "lubricants",
                        onClick: () => navigation("/category/lubricants"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Coolants",
                        key: "coolants",
                        onClick: () => navigation("/category/coolants"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Filters",
                        key: "filtergfgfgfs",
                        onClick: () => navigation("/category/filters"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Tyre Gauge",
                        key: "tyre-gauge",
                        onClick: () => navigation("/category/tyre-gauge"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Jumper Cables",
                        key: "jumper-cables",
                        onClick: () => navigation("/category/jumper-cables"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Decal Magnet Sticker",
                        key: "decal-magnet-sticker",
                        onClick: () =>
                          navigation("/category/decal-magnet-sticker"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Puncture Repair Kits",
                        key: "puncture-repair-kits",
                        onClick: () =>
                          navigation("/category/puncture-repair-kits"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Tyre Wax Polish",
                        key: "tyre-wax-polish",
                        onClick: () => navigation("/category/tyre-wax-polish"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Number Plate Frames",
                        key: "number-plate-frames",
                        onClick: () =>
                          navigation("/category/number-plate-frames"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "Tyre Polish",
                        key: "tyre-polish",
                        onClick: () => navigation("/category/tyre-polish"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                      {
                        label: "GPS and Mobile Holder",
                        key: "gps-and-mobile-holder",
                        onClick: () =>
                          navigation("/category/gps-and-mobile-holder"),
                        className: `text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                ],
              },
            ]}
            style={{ width: "160px", border: "0px solid red" }}
          />

          <Menu
            mode="horizontal"
            className="  min-w-28 border-2"
            items={[
              {
                label: "BIKE ACCESSORIES",
                key: "hi",
                className: "text-black   ",
                children: [
                  {
                    label: "Shop By Bike",

                    key: "gu",

                    style: {
                      height: "fit-content",
                      width: "100%",
                      padding: 0,
                    },
                    children: [
                      {
                        label: <Bikemenu />,
                        key: "gu4",
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Motorcycle Accessories",

                    key: "guuuu",

                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: <Bikemenu2 />,
                        key: "gu3fdgsdf4s",
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Luggage & Touring",

                    key: "guuuu2",

                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: <Bikemenu3 />,
                        key: "g1u4s",
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Helmet & Accessories",

                    key: "guuuu3",

                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: <Bikemenu4 />,
                        key: "gu34s",
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                  {
                    label: "Riding Gears",

                    key: "guuuu5",

                    style: {
                      height: "fit-content",
                      width: "100%",
                    },
                    children: [
                      {
                        label: <Bikemenu5 />,
                        key: "gu44s",
                        className: ` text-black`,
                        style: {
                          height: "fit-content",
                          width: "100%",
                          padding: 0,
                        },
                      },
                    ],
                  },
                ],
              },
            ]}
            style={{ border: "0px solid red", width: "160px" }}
          />
        </div>
        {/* <div className="flex gap-2 md:gap-2    right-44  ">
          <div className="text-[22px] text-[#FF324D]">
          <ion-icon name="logo-whatsapp"></ion-icon>
           
          </div>
          <button className=" text-[17px]">98100-21158</button>
        </div> */}

        {showSidebar && (
          <div className="fixed z-50 top-0 right-1/2 h-full w-1/2 bg-white text-black p-6 transform translate-x-full transition-transform duration-300 ease-in-out">
            <button className="text-[30px]" onClick={handleSidebarToggle}>
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/">Car</Link>
              </li>
              <li>
                <Link to="/">Bike</Link>
              </li>
              <li>
                <Link to="/">Interiors</Link>
              </li>
              <li>
                <Link to="/">Exteriors</Link>
              </li>
              <li>
                <Link to="/">Lighting</Link>
              </li>
              <li>
                <Link to="/">Shop</Link>
              </li>
              <li>
                <Link to="/">Contact Us</Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Megamenu;
const customStyles = `
  .ant-menu-item {
    height: 30px; /* Set the desired height */
    line-height: 30px; /* Vertically center the text */
  }
`;

const Bike = () => {
  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(customStyles, styleSheet.cssRules.length);
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };

  return (
    <div className="bg-white px-10  ">
      <Menu
        mode="horizontal"
        className="  min-w-28 border-2"
        items={[
          {
            label: "BIKE ACCESSORIES",
            key: "hi",
            className: "text-black   ",
            children: [
              {
                label: "Shop By Bike",

                key: "gu",

                style: {
                  height: "fit-content",
                  width: "100%",
                  padding: 0,
                },
                children: [
                  {
                    label: <Bikemenu />,
                    key: "gu4",
                    className: ` text-black`,
                    style: {
                      height: "fit-content",
                      width: "100%",
                      padding: 0,
                    },
                  },
                ],
              },
              {
                label: "Motorcycle Accessories",

                key: "guuuu",

                style: {
                  height: "fit-content",
                  width: "100%",
                },
                children: [
                  {
                    label: <Bikemenu2 />,
                    key: "gu34s",
                    className: ` text-black`,
                    style: {
                      height: "fit-content",
                      width: "100%",
                      padding: 0,
                    },
                  },
                ],
              },
              {
                label: "Luggage & Touring",

                key: "guuuu2",

                style: {
                  height: "fit-content",
                  width: "100%",
                },
                children: [
                  {
                    label: <Bikemenu3 />,
                    key: "g5u4s",
                    className: ` text-black`,
                    style: {
                      height: "fit-content",
                      width: "100%",
                      padding: 0,
                    },
                  },
                ],
              },
              {
                label: "Helmet & Accessories",

                key: "guuuu3",

                style: {
                  height: "fit-content",
                  width: "100%",
                },
                children: [
                  {
                    label: <Bikemenu4 />,
                    key: "gu74s",
                    className: ` text-black`,
                    style: {
                      height: "fit-content",
                      width: "100%",
                      padding: 0,
                    },
                  },
                ],
              },
              {
                label: "Riding Gears",

                key: "guuuu5",

                style: {
                  height: "fit-content",
                  width: "100%",
                },
                children: [
                  {
                    label: <Bikemenu5 />,
                    key: "gdu4s",
                    className: ` text-black`,
                    style: {
                      height: "fit-content",
                      width: "100%",
                      padding: 0,
                    },
                  },
                ],
              },
            ],
          },
        ]}
      />
    </div>
  );
};

const Bigmenu = () => {
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };

  const chidlrenStyle = {
    height: "20px",
    lineHeight: "20px",
    paddingLeft: "15px",
  };

  return (
    <div className="bg-white px-10  " style={{ paddingBottom: "30px" }}>
      <Space align="start">
        <div className="  flex    ">
          <div className=" flex flex-col md:flex-row">
            <Menu
              items={[
                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>CAR SUNSHADES</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "CAR_SUNSHADES",
                  type: "group",
                  style: { title: "black" },

                  className: " text-gray-500  text-xs  font-bold    ",
                  style: { AntMenuItemGroupTitle: "black" },
                  children: [
                    {
                      label: "Fix Curtains",
                      key: "Fix_Curtains",
                      style: chidlrenStyle,
                      className: "ant-list-item",
                      onClick: () => navigation("/category/fix-curtains"),
                    },
                    {
                      label: "Magnet Curtains",
                      key: "Magnet_Curtains",
                      style: chidlrenStyle,

                      onClick: () => navigation("/category/magnet-curtains"),
                    },
                    {
                      label: "Front Windscreen Sunshade",
                      key: "Front_Windscreen_Sunshade",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/front-windscreen-sunshade"),
                    },
                    {
                      label: "Side Window Curtains",
                      key: "Side_Window_Curtains",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/side-window-curtains"),
                    },
                    {
                      label: "Rear Curtains",
                      key: "Rear_Curtains",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/rear-curtains"),
                    },
                    {
                      label: "Front Windscreen Sunshade - Internal",
                      key: "Front_Windscreen_Sunshade_Internal",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation(
                          "/category/front-windscreen-sunshade-internal"
                        ),
                    },
                  ],
                },

                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>CAR DOOR SCUFF SILL PLATES</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "CAR_DOOR_SCUFF_SILL_PLATES",
                  type: "group",
                  className: " text-gray-500  text-xs  font-bold    ",
                  style: { paddingLeft: "0px " },
                  children: [
                    {
                      label: "Steel",
                      key: "Steel",
                      className: "  text-left  px-0",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/steel"),
                    },
                    {
                      label: "Led",
                      key: "Led",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/led"),
                    },
                    {
                      label: "Rubber",
                      key: "Rubber",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/rubber"),
                    },
                    {
                      label: "Sticker and Decals",
                      key: "Sticker_and_Decals",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/sticker-and-decals"),
                    },
                  ],
                },
                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>CAR STEERING WHEEL COVERS</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "CAR_STEERING_WHEEL_COVERS",
                  type: "group",
                  className: " text-gray-500  text-xs  font-bold   ",
                  children: [
                    {
                      label: "Stitch Type Steering Cover",
                      key: "Stitch_Type_Steering_Cover",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/stitch-type-steering-cover"),
                    },
                    {
                      label: "Ring Type Steering Covers",
                      key: "Ring_Type_Steering_Covers",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/ring-type-steering-covers"),
                    },
                    {
                      label: "Steering Grips",
                      key: "Steering_Grips",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/steering-grips"),
                    },
                  ],
                },
              ]}
              style={{ boxShadow: "none", border: "none", padding: "0px 0px" }}
            />
            <Menu
              items={[
                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>CAR FLOOR MATS</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "CAR_FLOOR_MATS",

                  type: "group",
                  className: " text-gray-500  text-xs  font-bold   ",

                  children: [
                    {
                      label: "Carpet Mats",
                      key: "Carpet_Mats",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/carpet-mats"),
                    },
                    {
                      label: "Grass Mats",
                      key: "Grass_Mats",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/grass-mats"),
                    },
                    {
                      label: "3D Mats",
                      key: "3D_Mats",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/3d-mats"),
                    },
                    {
                      label: "5D Mats",
                      key: "5D_Mats",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/5d-mats"),
                    },
                    {
                      label: "7D Mats",
                      key: "7D_Mats",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/7d-mats"),
                    },
                    {
                      label: "Rubber Mats",
                      key: "Rubber_Mats",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/rubber-mats"),
                    },
                    {
                      label: "Boot Mats",
                      key: "Boot_Mats",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/boot-mats"),
                    },
                  ],
                },
                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>CAR AUDIO SYSTEMS</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "CAR_AUDIO_SYSTEMS",
                  type: "group",
                  className: " text-gray-500  text-xs  font-bold   ",
                  children: [
                    {
                      label: "Speakers",
                      key: "Speakers",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/car-audio-systems/speakers"),
                    },
                    {
                      label: "Base Tubes",
                      key: "Base Tubes",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/car-audio-systems/base-tubes"),
                    },
                    {
                      label: "Processors",
                      key: "Processors",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/car-audio-systems/processors"),
                    },
                    {
                      label: "Amplifiers",
                      key: "Amplifiers",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/car-audio-systems/amplifiers"),
                    },
                    {
                      label: "Dumping Sheets",
                      key: "Dumping Sheets",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation(
                          "/category/car-audio-systems/dumping-sheets"
                        ),
                    },
                  ],
                },

                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>GAR BOOT COVER AND KNOBS</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "GAR_BOOT_COVER_AND_KNOBS",
                  type: "group",
                  className: " text-gray-500  text-xs  font-bold   ",
                  children: [
                    {
                      label: "gear-knobs",
                      key: "gear-knobs",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/gear-knobs"),
                    },
                    {
                      label: "gear-extender",
                      key: "gear-extender",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/gear-extender"),
                    },
                  ],
                },
              ]}
              style={{ boxShadow: "none", border: "none" }}
            />
          </div>
          <div className="  flex">
            <Menu
              items={[
                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>CAR CARE & STYLING</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "CAR_CARE_STYLING",
                  type: "group",
                  className: " text-gray-500  text-xs  font-bold   ",

                  children: [
                    {
                      label: "Car Organizers",
                      key: "Car_Organizers",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/car-organizers"),
                    },
                    {
                      label: "Tissue Box",
                      key: "Tissue_Box",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/tissue-box"),
                    },
                    {
                      label: "Boot Organisers",
                      key: "Boot_Organisers",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/boot-organisers"),
                    },
                    {
                      label: "Car Seat Cushion",
                      key: "Car_Seat_Cushion",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/car-seat-cushion"),
                    },
                    {
                      label: "Gear Knobs",
                      key: "Gear_Knobs",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/gear-knobs"),
                    },
                    {
                      label: "Blind Spots Mirror",
                      key: "Blind_Spots_Mirror",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/blind-spots-mirror"),
                    },
                    {
                      label: "Fender Blind Sport Mirror",
                      key: "Fender_Blind_Sport_Mirror",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/fender-blind-sport-mirror"),
                    },
                    {
                      label: "Key Covers",
                      key: "Key_Covers",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/key-covers"),
                    },
                    {
                      label: "Polish and Wax",
                      key: "Polish_and_Wax",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/polish-and-wax"),
                    },
                    {
                      label: "Scratch Remover",
                      key: "Scratch_Remover",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/scratch-remover"),
                    },
                    {
                      label: "Shampoos",
                      key: "Shampoos",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/shampoos"),
                    },
                  ],
                },
                {
                  label: (
                    <span style={{ color: "black" }}>
                      <p>CAR ARMREST</p>
                      <hr style={{ border: "0.5px solid black" }} />
                    </span>
                  ),
                  key: "CAR_ARMREST",
                  type: "group",
                  className: " text-gray-500  text-xs  font-bold   ",
                  children: [
                    {
                      label: "Armrest",
                      key: "Armrest",
                      style: chidlrenStyle,
                      onClick: () => navigation("/category/armrest"),
                    },
                    {
                      label: "Armrest with Glass Holder",
                      key: "Armrest with Glass Holder",
                      style: chidlrenStyle,
                      onClick: () =>
                        navigation("/category/armrest-with-glass-holder"),
                    },
                  ],
                },
              ]}
              style={{ boxShadow: "none", border: "none" }}
            />
          </div>
        </div>
      </Space>
    </div>
  );
};
const Bikemenu = () => {
  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(customStyles, styleSheet.cssRules.length);
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };
  const chidlrenStyle = {
    height: "20px",
    lineHeight: "20px",
    paddingLeft: "15px",
  };

  return (
    <div className="bg-white px-10  " style={{ paddingBottom: "30px" }}>
      <Space align="start">
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  Royal Enfield <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Royal_Enfield",
              type: "group",
              className: "text-gray-500 text-xs font-bold",

              children: [
                {
                  label: (
                    <span style={{ color: "grey" }}>Super Meteor 650</span>
                  ),
                  key: "Super_Meteor_650",
                  onClick: () => navigation("/category/super-meteor-650"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Hunter 350</span>,
                  key: "Hunter_350",
                  onClick: () => navigation("/category/hunter-350"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Himalayan</span>,
                  key: "Himalayan",
                  onClick: () => navigation("/category/himalayan"),
                  style: chidlrenStyle,
                },
                {
                  label: (
                    <span style={{ color: "grey" }}>Classic 350 Reborn</span>
                  ),
                  key: "Classic_350_Reborn",
                  onClick: () => navigation("/category/classic-350-reborn"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Meteor 350</span>,
                  key: "Meteor_350",
                  onClick: () => navigation("/category/meteor-350"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Classic</span>,
                  key: "Classic",
                  onClick: () => navigation("/category/classic"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Standard</span>,
                  key: "Standard",
                  onClick: () => navigation("/category/standard"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Electra</span>,
                  key: "Electra",
                  onClick: () => navigation("/category/electra"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Interceptor</span>,
                  key: "Interceptor",
                  onClick: () => navigation("/category/interceptor"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>ThunderBird</span>,
                  key: "ThunderBird",
                  onClick: () => navigation("/category/thunderbird"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>ThunderBird X</span>,
                  key: "ThunderBird_X",
                  onClick: () => navigation("/category/thunderbird-x"),
                  style: chidlrenStyle,
                },
                {
                  label: <span style={{ color: "grey" }}>Continental GT</span>,
                  key: "Continental_GT",
                  onClick: () => navigation("/category/continental-gt"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Ather <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Ather",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Ather",
                  key: "Ather",
                  onClick: () => navigation("/category/Ather"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  TVS <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "TVS",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "TVS Ronin",
                  key: "TVS_Ronin",
                  onClick: () => navigation("/category/tvs-ronin"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Ola <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Ola",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Ola",
                  key: "Ola",
                  onClick: () => navigation("/category/ola"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Hero <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Hero",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Impulse",
                  key: "Impulse",
                  onClick: () => navigation("/category/impulse"),
                  style: chidlrenStyle,
                },
                {
                  label: "Xpulse 200",
                  key: "Xpulse_200",
                  onClick: () => navigation("/category/xpulse-200"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none", padding: "0px" }}
        />
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  Yamaha <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Yamaha",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "MT 15",
                  key: "MT_15",
                  onClick: () => navigation("/category/mt-15"),
                  style: chidlrenStyle,
                },
                {
                  label: "R3",
                  key: "R3",
                  onClick: () => navigation("/category/r3"),
                  style: chidlrenStyle,
                },
                {
                  label: "R15 V1",
                  key: "R15_V1",
                  onClick: () => navigation("/category/r15-v1"),
                  style: chidlrenStyle,
                },
                {
                  label: "R15 V2",
                  key: "R15_V2",
                  onClick: () => navigation("/category/r15-v2"),
                  style: chidlrenStyle,
                },
                {
                  label: "R15 V3",
                  key: "R15_V3",
                  onClick: () => navigation("/category/r15-v3"),
                  style: chidlrenStyle,
                },
                {
                  label: "R15 V4",
                  key: "R15_V4",
                  onClick: () => navigation("/category/r15-v4"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Honda <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Honda",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Hornet 160R",
                  key: "Hornet_160R",
                  onClick: () => navigation("/category/hornet-160r"),
                  style: chidlrenStyle,
                },
                {
                  label: "CBR 250R",
                  key: "CBR_250R",
                  onClick: () => navigation("/category/cbr-250r"),
                  style: chidlrenStyle,
                },
                {
                  label: "CB300",
                  key: "CB300",
                  onClick: () => navigation("/category/cb300"),
                  style: chidlrenStyle,
                },
                {
                  label: "CB 350 RS",
                  key: "CB_350_RS",
                  onClick: () => navigation("/category/cb-350-rs"),
                  style: chidlrenStyle,
                },
                {
                  label: "CB 500X",
                  key: "CB_500X",
                  onClick: () => navigation("/category/cb-500x"),
                  style: chidlrenStyle,
                },
                {
                  label: "HNESS CB 350",
                  key: "HNESS_CB_350",
                  onClick: () => navigation("/category/hness-cb-350"),
                  style: chidlrenStyle,
                },
                {
                  label: "BC 200X",
                  key: "BC_200X",
                  onClick: () => navigation("/category/bc-200x"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Suzuki
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Suzuki",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Gixxer",
                  key: "Gixxer",
                  onClick: () => navigation("/category/gixxer"),
                  style: chidlrenStyle,
                },
                {
                  label: "Gixxer SF",
                  key: "Gixxer_SF",
                  onClick: () => navigation("/category/gixxer-sf"),
                  style: chidlrenStyle,
                },
                {
                  label: "V Storm 250",
                  key: "V_Storm_250",
                  onClick: () => navigation("/category/v-storm-250"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  BMW <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "BMW",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "G 310GS",
                  key: "G_310GS",
                  onClick: () => navigation("/category/g-310gs"),
                  style: chidlrenStyle,
                },
                {
                  label: "G310R",
                  key: "G310R",
                  onClick: () => navigation("/category/g310r"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none" }}
        />
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  KTM <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "KTM",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Duke 125",
                  key: "Duke_125",
                  onClick: () => navigation("/category/duke-125"),
                  style: chidlrenStyle,
                },
                {
                  label: "Duke 250",
                  key: "Duke_250",
                  onClick: () => navigation("/category/duke-250"),
                  style: chidlrenStyle,
                },
                {
                  label: "Duke 250 BS 6",
                  key: "Duke_250_BS_6",
                  onClick: () => navigation("/category/duke-250-bs-6"),
                  style: chidlrenStyle,
                },
                {
                  label: "Duke 390",
                  key: "Duke_390",
                  onClick: () => navigation("/category/duke-390"),
                  style: chidlrenStyle,
                },
                {
                  label: "RC 390",
                  key: "RC_390",
                  onClick: () => navigation("/category/rc-390"),
                  style: chidlrenStyle,
                },
                {
                  label: "Adventure 390",
                  key: "Adventure_390",
                  onClick: () => navigation("/category/adventure-390"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black", textAlign: "center" }}>
                  Bajaj
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Bajaj",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Pulsar 220",
                  key: "Pulsar_220",
                  onClick: () => navigation("/category/pulsar-220"),
                  style: chidlrenStyle,
                },
                {
                  label: "Pulsar NS 200",
                  key: "Pulsar_NS_200",
                  onClick: () => navigation("/category/pulsar-ns-200"),
                  style: chidlrenStyle,
                },
                {
                  label: "Pulsar RS 200",
                  key: "Pulsar_RS_200",
                  onClick: () => navigation("/category/pulsar-rs-200"),
                  style: chidlrenStyle,
                },
                {
                  label: "Dominar 400",
                  key: "Dominar_400",
                  onClick: () => navigation("/category/dominar-400"),
                  style: chidlrenStyle,
                },
                {
                  label: "Pulsar 150",
                  key: "Pulsar_150",
                  onClick: () => navigation("/category/pulsar-150"),
                  style: chidlrenStyle,
                },
                {
                  label: "Pulsar 180",
                  key: "Pulsar_180",
                  onClick: () => navigation("/category/pulsar-180"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Triumph <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Triumph",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Tiger",
                  key: "Tiger",
                  onClick: () => navigation("/category/tiger"),
                  style: chidlrenStyle,
                },
                {
                  label: "Speed 400",
                  key: "Speed_400",
                  onClick: () => navigation("/category/speed-400"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Kawasaki <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Kawasaki",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Ninja 300",
                  key: "Ninja_300",
                  onClick: () => navigation("/category/ninja-300"),
                  style: chidlrenStyle,
                },
                {
                  label: "Z 900",
                  key: "Z_900",
                  onClick: () => navigation("/category/z-900"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none" }}
        />
        {/* <Menu
          items={[
            
          ]}
          style={{ boxShadow: "none", border: "none" }}
        /> */}
      </Space>
    </div>
  );
};
const Bikemenu3 = () => {
  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(customStyles, styleSheet.cssRules.length);
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };

  const chidlrenStyle = {
    height: "20px",
    lineHeight: "20px",
    paddingLeft: "15px",
  };

  return (
    <div className="bg-white px-10  " style={{ paddingBottom: "30px" }}>
      <Space align="start">
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  Bags and Backpacks{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "BAGS_AND_BACKPACKS",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Back Pack",
                  key: "BACK_PACK",
                  onClick: () => navigation("/category/back-pack"),
                  style: chidlrenStyle,
                },
                {
                  label: "Saddle Bag",
                  key: "SADDLE_BAG",
                  onClick: () => navigation("/category/saddle-bag"),
                  style: chidlrenStyle,
                },
                {
                  label: "Tank Bag",
                  key: "TANK_BAG",
                  onClick: () => navigation("/category/tank-bag"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Touring Accessories{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "TOURING_ACCESSORIES",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Saddle Stay",
                  key: "SADDLE_STAY",
                  onClick: () => navigation("/category/saddle-stay"),
                  style: chidlrenStyle,
                },
                {
                  label: "Jerry Can and Mounts",
                  key: "JERRY_CAN_AND_MOUNTS",
                  onClick: () => navigation("/category/jerry-can-and-mounts"),
                  style: chidlrenStyle,
                },
                {
                  label: "Bungee Cords and Nets",
                  key: "BUNGEE_CORDS_AND_NETS",
                  onClick: () => navigation("/category/bungee-cords-and-nets"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Luggage Accessories{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "LUGGAGE_ACCESSORIES",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Aluminium Top Cases and Panniers",
                  key: "ALUMINIUM_TOP_CASES_AND_PANNIERS",
                  onClick: () =>
                    navigation("/category/aluminium-top-cases-and-panniers"),
                  style: chidlrenStyle,
                },
                {
                  label: "Plastic Top Case and Panniers",
                  key: "PLASTIC_TOP_CASE_AND_PANNIERS",
                  onClick: () =>
                    navigation("/category/plastic-top-case-and-panniers"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Carriers and Backrest{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "CARRIERS_AND_BACKREST",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Carriers and BackPack",
                  key: "CARRIERS_AND_BACKPACK",
                  onClick: () => navigation("/category/carriers-and-backpack"),
                  style: chidlrenStyle,
                },
                {
                  label: "Back Rest",
                  key: "BACK_REST",
                  onClick: () => navigation("/category/back-rest"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none", padding: "0px" }}
        />
      </Space>
    </div>
  );
};
const Bikemenu4 = () => {
  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(customStyles, styleSheet.cssRules.length);
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };

  const chidlrenStyle = {
    height: "20px",
    lineHeight: "20px",
    paddingLeft: "15px",
  };

  return (
    <div className="bg-white px-10  " style={{ paddingBottom: "30px" }}>
      <Space align="start">
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  Helmet <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "HELMET",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Full Face Helmet",
                  key: "FULL_FACE_HELMET",
                  onClick: () => navigation("/category/full-face-helmet"),
                  style: chidlrenStyle,
                },
                {
                  label: "Half Face Helmet",
                  key: "HALF_FACE_HELMET",
                  onClick: () => navigation("/category/half-face-helmet"),
                  style: chidlrenStyle,
                },
                {
                  label: "OffRoad Helmets",
                  key: "OFFROAD_HELMETS",
                  onClick: () => navigation("/category/offroad-helmets"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Accessories <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "ACCESSORIES",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Goggles",
                  key: "GOGGLES",
                  onClick: () => navigation("/category/goggles"),
                  style: chidlrenStyle,
                },
                {
                  label: "Helmet Accessories",
                  key: "HELMET_ACCESSORIES",
                  onClick: () => navigation("/category/helmet-accessories"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Rider Tech <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "RIDER_TECH",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Action Camera and Accessories",
                  key: "ACTION_CAMERA_AND_ACCESSORIES",
                  onClick: () =>
                    navigation("/category/action-camera-and-accessories"),
                  style: chidlrenStyle,
                },
                {
                  label: "Communication",
                  key: "COMMUNICATION",
                  onClick: () => navigation("/category/communication"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{
            boxShadow: "none",
            border: "none",
            padding: "0px",
            margin: "0px",
          }}
        />
      </Space>
    </div>
  );
};
const Bikemenu5 = () => {
  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(customStyles, styleSheet.cssRules.length);
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };

  const chidlrenStyle = {
    height: "20px",
    lineHeight: "20px",
    paddingLeft: "15px",
  };

  return (
    <div className="bg-white px-10  " style={{ paddingBottom: "30px" }}>
      <Space align="start">
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  Rider Protection{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "RIDER_PROTECTION",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Jackets",
                  key: "JACKETS",
                  onClick: () => navigation("/category/jackets"),
                  style: chidlrenStyle,
                },
                {
                  label: "Gloves",
                  key: "GLOVES",
                  onClick: () => navigation("/category/gloves"),
                  style: chidlrenStyle,
                },
                {
                  label: "Pants",
                  key: "PANTS",
                  onClick: () => navigation("/category/pants"),
                  style: chidlrenStyle,
                },
                {
                  label: "Boots",
                  key: "BOOTS",
                  onClick: () => navigation("/category/boots"),
                  style: chidlrenStyle,
                },
                {
                  label: "Rider Guards",
                  key: "RIDER_GUARDS",
                  onClick: () => navigation("/category/rider-guards"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Casuals <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "CASUALS",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Face Mask and Balaclava",
                  key: "FACE_MASK_AND_BALACLAVA",
                  onClick: () =>
                    navigation("/category/face-mask-and-balaclava"),
                  style: chidlrenStyle,
                },
                {
                  label: "Rain Coats",
                  key: "RAIN_COATS",
                  onClick: () => navigation("/category/rain-coats"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none", padding: "0px" }}
        />
      </Space>
    </div>
  );
};
const Bikemenu2 = () => {
  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(customStyles, styleSheet.cssRules.length);
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };

  const chidlrenStyle = {
    height: "20px",
    lineHeight: "20px",
    paddingLeft: "15px",
  };

  return (
    <div className="bg-white px-10  " style={{ paddingBottom: "30px" }}>
      <Space align="start">
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  BIKE ESSENTIALS <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "BIKE_ESSENTIALS",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "GRIPS AND THROTTLES",
                  key: "GRIPS_AND_THROTTLES",
                  onClick: () => navigation("/category/grips-and-throttles"),
                  style: chidlrenStyle,
                },
                {
                  label: "HAND GUARDS",
                  key: "HAND_GUARDS",
                  onClick: () => navigation("/category/hand-guards"),
                  style: chidlrenStyle,
                },
                {
                  label: "HANDLE BARS",
                  key: "HANDLE_BARS",
                  onClick: () => navigation("/category/handle-bars"),
                  style: chidlrenStyle,
                },
                {
                  label: "HANDLE RISERS",
                  key: "HANDLE_RISERS",
                  onClick: () => navigation("/category/handle-risers"),
                  style: chidlrenStyle,
                },
                {
                  label: "LEVER GUARDS",
                  key: "LEVER_GUARDS",
                  onClick: () => navigation("/category/lever-guards"),
                  style: chidlrenStyle,
                },
                {
                  label: "MIRROR",
                  key: "MIRROR",
                  onClick: () => navigation("/category/mirror"),
                  style: chidlrenStyle,
                },
                {
                  label: "MOUNTS AND CHARGERS",
                  key: "MOUNTS_AND_CHARGERS",
                  onClick: () => navigation("/category/mounts-and-chargers"),
                  style: chidlrenStyle,
                },
                {
                  label: "HANDLE ACCESSORIES",
                  key: "HANDLE_ACCESSORIES",
                  onClick: () => navigation("/category/handle-accessories"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Lightning <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Lightning",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "TAIL LIGHT",
                  key: "TAIL_LIGHT",
                  onClick: () => navigation("/category/tail-light"),
                  style: chidlrenStyle,
                },
                {
                  label: "AUXILIARY LIGHT",
                  key: "AUXILIARY_LIGHT",
                  onClick: () => navigation("/category/auxiliary-light"),
                  style: chidlrenStyle,
                },
                {
                  label: "LIGHT ACCESSORIES",
                  key: "LIGHT_ACCESSORIES",
                  onClick: () => navigation("/category/light-accessories"),
                  style: chidlrenStyle,
                },
                {
                  label: "INDICATOR",
                  key: "INDICATOR",
                  onClick: () => navigation("/category/indicator"),
                  style: chidlrenStyle,
                },
                {
                  label: "HEADLIGHT",
                  key: "HEADLIGHT",
                  onClick: () => navigation("/category/headlight"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Performance Accessories{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Performance_Accessories",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "AirFilter",
                  key: "AirFilter",
                  onClick: () => navigation("/category/air-filter"),
                  style: chidlrenStyle,
                },
                {
                  label: "Exhaust",
                  key: "Exhaust",
                  onClick: () => navigation("/category/exhaust"),
                  style: chidlrenStyle,
                },
                {
                  label: "Performance",
                  key: "Performance",
                  onClick: () => navigation("/category/performance"),
                  style: chidlrenStyle,
                },
                {
                  label: "Exhaust Accessories",
                  key: "Exhaust_Accessories",
                  onClick: () => navigation("/category/exhaust-accessories"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none", padding: "0px" }}
        />
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  BIKE PROTECTION <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "BIKE_PROTECTION",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "LOCK SYSTEM",
                  key: "LOCK_SYSTEM",
                  onClick: () => navigation("/category/lock-system"),
                  style: chidlrenStyle,
                },
                {
                  label: "WINDSHIELD",
                  key: "WINDSHIELD",
                  onClick: () => navigation("/category/windshield"),
                  style: chidlrenStyle,
                },
                {
                  label: "CRASH GUARD",
                  key: "CRASH_GUARD",
                  onClick: () => navigation("/category/crash-guard"),
                  style: chidlrenStyle,
                },
                {
                  label: "WINGLET",
                  key: "WINGLET",
                  onClick: () => navigation("/category/winglet"),
                  style: chidlrenStyle,
                },
                {
                  label: "FRAME SLIDER",
                  key: "FRAME_SLIDER",
                  onClick: () => navigation("/category/frame-slider"),
                  style: chidlrenStyle,
                },
                {
                  label: "HANDLE BARS",
                  key: "HANDLE_BARS",
                  onClick: () => navigation("/category/handle-bars"),
                  style: chidlrenStyle,
                },
                {
                  label: "FLUID GUARDS AND CAP",
                  key: "FLUID_GUARDS_AND_CAP",
                  onClick: () => navigation("/category/fluid-guards-and-cap"),
                  style: chidlrenStyle,
                },
                {
                  label: "HANDLE RISERS",
                  key: "HANDLE_RISERS",
                  onClick: () => navigation("/category/handle-risers"),
                  style: chidlrenStyle,
                },
                {
                  label: "MASTER CYLINDER GUARD",
                  key: "MASTER_CYLINDER_GUARD",
                  onClick: () => navigation("/category/master-cylinder-guard"),
                  style: chidlrenStyle,
                },
                {
                  label: "LEVER GUARDS",
                  key: "LEVER_GUARDS",
                  onClick: () => navigation("/category/lever-guards"),
                  style: chidlrenStyle,
                },
                {
                  label: "ENGINE GUARD AND SKID PLATE",
                  key: "ENGINE_GUARD_AND_SKID_PLATE",
                  onClick: () =>
                    navigation("/category/engine-guard-and-skid-plate"),
                  style: chidlrenStyle,
                },
                {
                  label: "MIRROR",
                  key: "MIRROR",
                  onClick: () => navigation("/category/mirror"),
                  style: chidlrenStyle,
                },
                {
                  label: "HEADLIGHT GRILL",
                  key: "HEADLIGHT_GRILL",
                  onClick: () => navigation("/category/headlight-grill"),
                  style: chidlrenStyle,
                },
                {
                  label: "MOUNTS AND CHARGERS",
                  key: "MOUNTS_AND_CHARGERS",
                  onClick: () => navigation("/category/mounts-and-chargers"),
                  style: chidlrenStyle,
                },
                {
                  label: "HANDLE ACCESSORIES",
                  key: "HANDLE_ACCESSORIES",
                  onClick: () => navigation("/category/handle-accessories"),
                  style: chidlrenStyle,
                },
                {
                  label: "TANK PROTECTORS",
                  key: "TANK_PROTECTORS",
                  onClick: () => navigation("/category/tank-protectors"),
                  style: chidlrenStyle,
                },
                {
                  label: "BODY COVER",
                  key: "BODY_COVER",
                  onClick: () => navigation("/category/body-cover"),
                  style: chidlrenStyle,
                },
                {
                  label: "SCREEN PROTECTORS",
                  key: "SCREEN_PROTECTORS",
                  onClick: () => navigation("/category/screen-protectors"),
                  style: chidlrenStyle,
                },
                {
                  label: "STAND AND EXTENDERS",
                  key: "STAND_AND_EXTENDERS",
                  onClick: () => navigation("/category/stand-and-extenders"),
                  style: chidlrenStyle,
                },
                {
                  label: "CHAIN COVER AND SPROCKET",
                  key: "CHAIN_COVER_AND_SPROCKET",
                  onClick: () =>
                    navigation("/category/chain-cover-and-sprocket"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none" }}
        />
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  Handle Bars and Accessories
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "HANDLE_BARS_AND_ACCESSORIES",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Grips and Throttles",
                  key: "GRIPS_AND_THROTTLES",
                  onClick: () => navigation("/category/grips-and-throttles"),
                  style: chidlrenStyle,
                },
                {
                  label: "Hand Guards",
                  key: "HAND_GUARDS",
                  onClick: () => navigation("/category/hand-guards"),
                  style: chidlrenStyle,
                },
                {
                  label: "Handle Bars",
                  key: "HANDLE_BARS",
                  onClick: () => navigation("/category/handle-bars"),
                  style: chidlrenStyle,
                },
                {
                  label: "Handle Risers",
                  key: "HANDLE_RISERS",
                  onClick: () => navigation("/category/handle-risers"),
                  style: chidlrenStyle,
                },
                {
                  label: "Lever Guards",
                  key: "LEVER_GUARDS",
                  onClick: () => navigation("/category/lever-guards"),
                  style: chidlrenStyle,
                },
                {
                  label: "Mirror",
                  key: "MIRROR",
                  onClick: () => navigation("/category/mirror"),
                  style: chidlrenStyle,
                },
                {
                  label: "Mounts and Chargers",
                  key: "MOUNTS_AND_CHARGERS",
                  onClick: () => navigation("/category/mounts-and-chargers"),
                  style: chidlrenStyle,
                },
                {
                  label: "Handle Accessories",
                  key: "HANDLE_ACCESSORIES",
                  onClick: () => navigation("/category/handle-accessories"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Body Fairing and Fenders{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Body_Fairing_and_Fenders",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Body Fairing",
                  key: "Body_Fairing",
                  onClick: () => navigation("/category/body-fairing"),
                  style: chidlrenStyle,
                },
                {
                  label: "Fenders and Extenders",
                  key: "Fenders_and_Extenders",
                  onClick: () => navigation("/category/fenders-and-extenders"),
                  style: chidlrenStyle,
                },
                {
                  label: "Tail Tidy",
                  key: "Tail_Tidy",
                  onClick: () => navigation("/category/tail-tidy"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Foot Controls <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Foot_Controls",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Foot Pegs and Mounts",
                  key: "Foot_Pegs_and_Mounts",
                  onClick: () => navigation("/category/foot-pegs-and-mounts"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Cleaning Accessories{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Cleaning_Accessories",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Cleaning Accessories",
                  key: "Cleaning_Accessories",
                  onClick: () => navigation("/category/cleaning-accessories"),
                  style: chidlrenStyle,
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  Wheel Accessories{" "}
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "Wheel_Accessories",
              type: "group",
              className: "text-gray-500 text-xs font-bold",
              AntMenuItemGroupTitle: "black",
              children: [
                {
                  label: "Wheel Cover",
                  key: "Wheel_Cover",
                  onClick: () => navigation("/category/wheel-cover"),
                  style: chidlrenStyle,
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none" }}
        />
      </Space>
    </div>
  );
};
const Bigmenu2 = () => {
  const navigation = useNavigate();
  const change = (name) => {
    const formattedName = name.replace(/\s+/g, "-").toLowerCase();
    navigation(formattedName);
  };
  const chidlrenStyle = {
    height: "20px",
    lineHeight: "20px",
    paddingLeft: "15px",
  };
  return (
    <div className="bg-white px-10 " style={{ paddingBottom: "30px" }}>
      <Space align="start">
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  <p>CAR BODY COVERS</p>
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "CAR_BODY_COVERS",
              type: "group",

              className: " text-gray-500  text-xs  font-bold   ",
              children: [
                {
                  label: "Grey",
                  key: "Grey",
                  style: chidlrenStyle,
                  onClick: () => navigation("/category/grey"),
                },
                {
                  label: "Silver",
                  key: "Silver",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/silver"),
                },
                {
                  label: "Blue",
                  key: "Blue",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/blue"),
                },
                {
                  label: "Blue and Red",
                  key: "Blue_and_Red",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/blue-and-red"),
                },
                {
                  label: "Blue and Blue",
                  key: "Blue_and_Blue",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/blue-and-blue"),
                },
                {
                  label: "Magic Silver",
                  key: "Magic_Silver",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/magic-silver"),
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none", padding: "0px" }}
        />
        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  <p>CAR HORNS</p>
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "CAR_HORNS",
              type: "group",
              className: " text-gray-500  text-xs  font-bold   ",
              children: [
                {
                  label: "Hella",
                  key: "Hella",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/hella"),
                },
                {
                  label: "Navik",
                  key: "Navik",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/navik"),
                },
                {
                  label: "Minda",
                  key: "Minda",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/minda"),
                },
                {
                  label: "Bosch",
                  key: "Bosch",

                  style: chidlrenStyle,

                  onClick: () => navigation("/category/bosch"),
                },
                {
                  label: "Caros",
                  key: "Caros",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/caros"),
                },
              ],
            },
            {
              label: (
                <span style={{ color: "black" }}>
                  <p>DOOR VISORS</p>
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "DOOR_VISORS",
              type: "group",
              className: " text-gray-500  text-xs  font-bold   ",
              children: [
                {
                  label: "Basic",
                  key: "Basic",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/basic-door-visors"),
                },
                {
                  label: "Chrome Line",
                  key: "Chrome_Line",
                  style: chidlrenStyle,

                  onClick: () =>
                    navigation("/category/chrome-line-door-visors"),
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none" }}
        />

        <Menu
          items={[
            {
              label: (
                <span style={{ color: "black" }}>
                  <p>CHROME ACCESSORIES</p>
                  <hr style={{ border: "0.5px solid black" }} />
                </span>
              ),
              key: "CHROME_ACCESSORIES",
              type: "group",
              style: { label: "red" },
              className: " text-gray-500  text-xs  font-bold   ",
              children: [
                {
                  label: "Tail Light",
                  key: "Tail_Light",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/tail-light"),
                },
                {
                  label: "Head Light",
                  key: "Head_Light",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/head-light"),
                },
                {
                  label: "Side Mirror",
                  key: "Side_Mirror",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/side-mirror"),
                },
                {
                  label: "Handle",
                  key: "Handle",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/handle"),
                },
                {
                  label: "Dicky",
                  key: "Dicky",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/dicky"),
                },
                {
                  label: "Door",
                  key: "Door",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/door"),
                },
                {
                  label: "Fog Light",
                  key: "Fog_Light",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/fog-light"),
                },
                {
                  label: "Indicator",
                  key: "Indicator",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/indicator"),
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none" }}
        />

        {/* <Menu
          items={[
            {
              label: <span style={{ color: "black" }}>
              <p>DOOR VISORS</p>
              <hr style={{ border: "0.5px solid black" }} />
            </span>,
              key: "DOOR_VISORS",
              type: "group",
              className: " text-gray-500  text-xs  font-bold   ",

              children: [
                {
                  label: "Basic",
                  key: "Basic",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/basic-door-visors"),
                },
                {
                  label: "Chrome Line",
                  key: "Chrome_Line",
                  style: chidlrenStyle,

                  onClick: () =>
                    navigation("/category/chrome-line-door-visors"),
                },
              ],
            },

            {
              label: <span style={{ color: "black" }}>DOOR VISORS</span>,
              key: "DOOR_VISORS",
              type: "group",
              className: " text-gray-500  text-xs  font-bold   ",
              children: [
                {
                  label: "Basic",
                  key: "Basic",
                  style: chidlrenStyle,

                  onClick: () => navigation("/category/basic-door-visors"),
                },
                {
                  label: "Chrome Line",
                  key: "Chrome_Line",
                  style: chidlrenStyle,

                  onClick: () =>
                    navigation("/category/chrome-line-door-visors"),
                },
              ],
            },
          ]}
          style={{ boxShadow: "none", border: "none" }}
        /> */}
      </Space>
    </div>
  );
};
